import { render, staticRenderFns } from "./celebrity-bio.vue?vue&type=template&id=63b8ce32&lang=pug&"
import script from "./celebrity-bio.vue?vue&type=script&lang=js&"
export * from "./celebrity-bio.vue?vue&type=script&lang=js&"
import style0 from "./celebrity-bio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports